import table from './table';
import form from './form';

export default {
  layout: 'claims-layout',
  table,
  form,
};
